import React, { FunctionComponent } from 'react'
import { Window } from '@progress/kendo-react-dialogs';
import { useGetTenantQuery } from '../../../redux/api/BaseApi';
import { trimChar } from '../../../utils/utils';


const KBPreview: FunctionComponent<KBPreviewArgs> = props => {
    const { data: tenant } = useGetTenantQuery();
    return (
        <Window minimizeButton={() => null} className='kb-preview cool-window' modal={true} onClose={props.onClose} initialWidth={900} initialHeight={700} title={`Knowledge Base Article: KB${props.KB_ID}`}>
            <section className='relative grow flex flex-col' style={{ height: '100%' }}>
                <iframe title='KB Preview' className="grow z-0" src={`${trimChar(tenant?.Tenant_Url, '/')}/KBase/?Popup=1&KB_Id=${props.KB_ID}`}></iframe>
            </section>
        </Window>
    )
}

export type KBPreviewArgs = {
    KB_ID: number
    onClose: () => void
}
export default KBPreview;